import store from "../../../../store";
import { has } from "../../../../utils/menu-context";
import { commonInputPropField } from "../../inform/request/request.condition";
import { isOperationAndSubStanceTypeMain } from "./request.section";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (record.createBy === store.state.resource.auth.info.user?.username
                // || (record.createBy === "anonymousUser" && record.refHazTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
                || (record.refHazTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWaitReceive: ({ record }) => {
            let result = false;
            if ((record.createBy === store.state.resource.auth.info.user?.username
                // || (record.createBy === "anonymousUser" && record.refHazTemp?.refUser?.username === store.state.resource.auth.info.user?.username))
                || (record.refHazTemp?.refUser?.username === store.state.resource.auth.info.user?.username))
            ) {
                if (!record.isOfficerCreate && [undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (record.isOfficerCreate) {
                if (["draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canHsss: ({ record }) => {
            return record.hsssResponse || record.hsssError;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    if (record.refToApproveBy?.username === userInfo.username) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canReStatus: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canReport: ({ record }) => {
            return !["draft"].includes(record.refStatus?.key);
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return [
                    "refDepartment.nameEn",
                    "lastStatus.waitReceive.0.statusDatetime",
                    "lastStatus.draft.0.statusDatetime",
                    "lastStatus.waitApprove.0.statusDatetime",
                    "refHazTemp.refUserCompany.companyNameEn",
                    "refHazTemp.refUser.fullNameEn",
                    "refHazTemp.refUserCompany.addresses.0.addrTh",
                    "refHazTemp.refUser.addresses.0.addrTh"
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refHazTemp.refUserCompany.idCard"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refHazTemp.refUser.idCard"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refRequestType"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return ["refDocGenType", "requestCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refHazTemp.approveCode"].includes(field?.key);
            },
            visibleField: () => {
                return false;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refHazTemp.approveCode2"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refHazTemp.refUserCompany", "refDepartment"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refHazTemp.refUser"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refHaz"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2", "3", "4"].includes(modelRef.refRequestType?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return ["refHazTemp.refOperation"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    return { ...common, disabled: true };
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refHazTemp.effectiveDate",
                    "refHazTemp.approveManualDate",
                    // "refHazTemp.expireDate"
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    if (["2", "3", "4"].includes(modelRef.refRequestType?.key) && modelRef.refDocGenType?.key !== "2") {
                        return { ...common, disabled: true };
                    }
                    return common;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forReceiveRemark.0.remark"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    undefined,
                    "draft",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return [
                    "refHazTemp.refSubStanceType",
                    "refHazTemp.manufacturer",
                    "refHazTemp.refManufactureCountry",
                    "refHazTemp.ph",
                    "refHazTemp.refType",
                    "refHazTemp.refSubStanceTypeMain",
                    "refHazTemp.isTechnicalGrade",
                    "refHazTemp.refAnalysisAgency",
                    "refHazTemp.refAnalysisMethod",
                    "refHazTemp.isSubStanceActive",
                    "refHazTemp.refLd50",
                    "refHazTemp.ld50Operator",
                    "refHazTemp.ld50Value",
                    "refHazTemp.refSubStanceActive",
                    "refHazTemp.analysisResult",
                    "refHazTemp.subStanceMainQty",
                    "refHazTemp.refSubStanceMainUnit",
                    "refHazTemp.approveCodeOld"
                ].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            }),
            checkboxField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return [
                    "refHazTemp.refHazObject",
                    "refHazTemp.tradeNameTh",
                    "refHazTemp.tradeNameEn",
                    "refHazTemp.isSolid",
                    "refHazTemp.isLiquid",
                    "refHazTemp.solid",
                    "refHazTemp.liquid"
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                let enabled = undefined;
                const disabledStatuses = ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"];
                const disabledRequestTypes = ["3", "4"];
                if (disabledStatuses.includes(initialModel.refStatus?.key) || disabledRequestTypes.includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                if (modelRef.refRequestType?.key === "2" && !modelRef.isOfficerCreate) {
                    enabled = false;
                }
                return { disabled: enabled !== undefined ? !enabled : undefined };
            },
            checkboxField: ({ modelRef, initialModel }) => {
                let enabled = undefined;
                const disabledStatuses = ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"];
                const disabledRequestTypes = ["3", "4"];
                if (disabledStatuses.includes(initialModel.refStatus?.key) || disabledRequestTypes.includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                if (modelRef.refRequestType?.key === "2" && !modelRef.isOfficerCreate) {
                    enabled = false;
                }
                return { disabled: enabled !== undefined ? !enabled : undefined };
            }
        },
        {
            check: ({ field }) => {
                return ["refHazTemp.toUse"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refHazTemp.refType?.key === "1";
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refHazTemp.products"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refHazTemp.refType?.key === "2";
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refHazTemp.mainSubStances") && (field?.key?.endsWith("refSubStance") || field?.key?.endsWith("intense"))
                );
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refHazTemp.mainSubStances") &&
                    (field?.key?.endsWith("chemiAnalysisResult") || field?.key?.endsWith("qty") || field?.key?.endsWith("isBypassAnalysisResult"))
                );
            },
            visibleField: ({ modelRef, model }) => {
                return (
                    (isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: true })) &&
                    model.refSubStance?.refType?.key !== "media"
                );
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return field?.key?.startsWith("refHazTemp.mainSubStances") && field?.key?.endsWith("refMainSubStanceRate");
            },
            visibleField: ({ modelRef, model }) => {
                return (
                    (isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false })) &&
                    model.refSubStance?.refType?.key !== "media"
                );
            }
        },
        {
            check: ({ field }) => {
                return field?.key?.startsWith("refHazTemp.mainSubStances") && field?.key?.endsWith("refSubStance.casNo");
            },
            visibleField: ({ modelRef, model }) => {
                return (
                    (isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro", isTechnicalGrade: false }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro", isTechnicalGrade: false })) &&
                    model.refSubStance?.refType?.key !== "media"
                );
            }
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refHazTemp.mainSubStances") && (field?.key?.endsWith("isImport") || field?.key?.endsWith("isInternal"))
                );
            },
            visibleField: ({ modelRef, model }) => {
                return (
                    (isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro", isTechnicalGrade: false })) &&
                    model.refSubStance?.refType?.key !== "media"
                );
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return field?.key?.startsWith("refHazTemp.mainSubStances") && (field?.key?.endsWith("companies") || field?.key?.endsWith("products"));
            },
            visibleField: ({ modelRef, model }) => {
                return (
                    (isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro", isTechnicalGrade: false })) &&
                    model.refSubStance?.refType?.key !== "media"
                );
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refHazTemp.mainSubStances") &&
                    (field?.key?.endsWith("docNoRefer") || field?.key?.endsWith("attachments.0"))
                );
            },
            visibleField: ({ modelRef, model }) => {
                return (
                    (isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: false }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "chemi", isTechnicalGrade: true }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro", isTechnicalGrade: false })) &&
                    model.refSubStance?.refType?.key !== "media"
                );
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refHazTemp.mainSubStances") &&
                    (field?.key?.endsWith("microAnalysisResult1") ||
                        field?.key?.endsWith("microAnalysisResult2") ||
                        field?.key?.endsWith("microAnalysisResult3") ||
                        field?.key?.endsWith("microAnalysisQty1") ||
                        field?.key?.endsWith("microAnalysisQty2") ||
                        field?.key?.endsWith("microAnalysisQty3") ||
                        field?.key?.endsWith("refMicroUnit"))
                );
            },
            visibleField: ({ modelRef, model }) => {
                return (
                    (isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro" }) ||
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro" })) &&
                    model.refSubStance?.refType?.key !== "media"
                );
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return field?.key?.startsWith("refHazTemp.mainSubStances") && field?.key?.endsWith("refUnit");
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return field?.key?.startsWith("refHazTemp.pictograms") && field?.key?.endsWith("refPictogram");
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refHazTemp.aquatics") &&
                    (field?.key?.endsWith("refAquaticType") ||
                        field?.key?.endsWith("refSubAquaticType") ||
                        field?.key?.endsWith("qty") ||
                        field?.key?.endsWith("duration") ||
                        field?.key?.endsWith("refDurationUnit"))
                );
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refHazTemp.packages") &&
                    (field?.key?.endsWith("refPackage1") ||
                        field?.key?.endsWith("refPackage2") ||
                        field?.key?.endsWith("refPackage3") ||
                        field?.key?.endsWith("size") ||
                        field?.key?.endsWith("refUnit"))
                );
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refHazTemp.tests") &&
                    (field?.key?.endsWith("refAnalysisAgency") ||
                        field?.key?.endsWith("method") ||
                        field?.key?.endsWith("refAnimal") ||
                        field?.key?.endsWith("refAnimalSpecies") ||
                        field?.key?.endsWith("result") ||
                        field?.key?.endsWith("performance"))
                );
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return field?.key?.startsWith("refHazTemp.useRates") && (field?.key?.endsWith("useRate") || field?.key?.endsWith("method"));
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return field?.key?.startsWith("refHazTemp.distributors") && field?.key?.endsWith("refDistributor");
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refHazTemp.attachments") &&
                    (field?.key?.endsWith("documentName") ||
                        field?.key?.endsWith("attribute.documentNo") ||
                        field?.key?.endsWith("attribute.documentDate") ||
                        field?.key?.endsWith("attribute.documentExpiredDate") ||
                        field?.key?.endsWith("size"))
                );
            },
            inputPropField: ({ modelRef, initialModel, record }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                        if (record?.attribute?.isDisabledDocumentName) {
                            common.disabled = true;
                        }
                    }
                }
                return common;
            }
        },
        {
            check: ({ componentKey }) => {
                return ["HazMainSubStanceList", "HazAquaticList", "PackageList", "TestList", "UseRateList", "DistributorList"].includes(componentKey);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                let canCreate = false;
                let canDelete = false;
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                    canCreate = false;
                    canDelete = false;
                }
                return { canCreate, canDelete };
            }
        },
        {
            check: ({ componentKey }) => {
                return ["AttachmentInlineList"].includes(componentKey);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let canCreate = false;
                let canDelete = false;
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                return { canCreate, canDelete };
            }
        }
    ];
};
